



















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import TemplateTable from "@/components/contentset/manager/TemplateTable.vue";
import ContentConfiguration from "@/components/contentset/manager/ContentConfiguration.vue";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";

@Component({
  components: {
    TemplateTable,
    ContentConfiguration
  }
})
export default class PreviousContentVersion extends Vue {
  @Prop() public previousVersion: IContentSetVersion;
}
